<hw-page-header header="{{ 'pechkin.test-01.header-email' | translate }}" class="page-header">
  <div class="content float-right">
    <button type="button" class="button" nz-button nzType="primary" (click)="send()" [disabled]="!form.valid">
      {{ 'pechkin.test-01.btn.send' | translate }}
    </button>
  </div>
</hw-page-header>
<nz-content class="main">
  <form nz-form [formGroup]="form" novalidate *ngIf="form">
    <hw-form-row>
      <hw-form-item
        name="receivers"
        [required]="true"
        label="{{ 'pechkin.test-01.label.receivers' | translate }}"
        *hwFormCol>
        <nz-tag
          *ngFor="let receiver of form.value.receivers"
          [nzMode]="'closeable'"
          (nzAfterClose)="deleteReceiver(receiver)">
          {{ receiver }}
        </nz-tag>
        <nz-tag *ngIf="!inputVisibleReceiver" class="editable-tag" nzNoAnimation (click)="inputVisibleReceiver = true">
          <i nz-icon nzType="plus"></i> {{ 'pechkin.test-01.btn.add-receiver' | translate }}
        </nz-tag>
        <input
          nz-input
          *ngIf="inputVisibleReceiver"
          type="text"
          formControlName="newReceiver"
          (blur)="addReceiver()"
          (keydown.enter)="addReceiver()" />
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item
        name="subject"
        [required]="true"
        label="{{ 'pechkin.test-01.label.subject' | translate }}"
        *hwFormCol>
        <input nz-input formControlName="subject" />
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item name="template" label="{{ 'pechkin.test-01.label.template' | translate }}" *hwFormCol>
        <nz-select formControlName="template" (ngModelChange)="templateChange($event)">
          <nz-option *ngFor="let t of templates" [nzValue]="t" [nzLabel]="t.names | localName"></nz-option>
        </nz-select>
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item
        name="message"
        [required]="true"
        label="{{ 'pechkin.test-01.label.message' | translate }}"
        *hwFormCol>
        <textarea nz-input formControlName="message" [nzAutosize]="{ minRows: 2, maxRows: 8 }"> </textarea>
      </hw-form-item>
    </hw-form-row>
    <hw-form-row>
      <hw-form-item name="attachments" label="{{ 'pechkin.test-01.label.attachments-url' | translate }}" *hwFormCol>
        <div *ngFor="let attachment of form.value.attachment">
          {{ attachment.url }}
          <i nz-icon nzType="minus-circle-o" class="dynamic-delete-button" (click)="removeAttachment(attachment)"></i>
        </div>
        <input
          *ngIf="inputVisibleAttachment"
          nz-input
          formControlName="newAttachment"
          (blur)="addAttachment()"
          (keydown.enter)="addAttachment()" />
        <div>
          <button
            *ngIf="!inputVisibleAttachment"
            nz-button
            nzType="dashed"
            class="add-button"
            (click)="inputVisibleAttachment = true">
            <i nz-icon nzType="plus"></i>{{ 'pechkin.test-01.btn.add-attachment' | translate }}
          </button>
        </div>
      </hw-form-item>
    </hw-form-row>
  </form>
</nz-content>
